/* === Arquivo: src/components/Footer/Footer.js === */

import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <p className="footer-copyright">
          © {new Date().getFullYear()} Aetheries. Todos os direitos reservados.
        </p>
        <p className="footer-expandere">
          Uma iniciativa da Expandere Negociações e Participações Ltda.
        </p>
      </div>
    </footer>
  );
}

export default Footer;